
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 7.333a1.929 1.929 0 01-1.417-.583A1.929 1.929 0 016 5.333c0-.555.194-1.027.583-1.416A1.929 1.929 0 018 3.333c.556 0 1.028.195 1.417.584.389.389.583.86.583 1.416 0 .556-.194 1.028-.583 1.417A1.929 1.929 0 018 7.333zm-4.667 2c-.366 0-.68-.13-.941-.391A1.284 1.284 0 012 8V2.667c0-.367.13-.68.392-.942.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.261.392.575.392.942V8c0 .367-.13.68-.392.942a1.284 1.284 0 01-.941.391H3.333zM4.667 8h6.666c0-.367.13-.68.392-.942.261-.26.575-.391.942-.391V4c-.367 0-.68-.13-.942-.392a1.284 1.284 0 01-.392-.941H4.667c0 .366-.13.68-.392.941A1.284 1.284 0 013.333 4v2.667c.367 0 .68.13.942.391.261.261.392.575.392.942zM8 14.667L10.667 12l-.934-.933-1.066 1.066V10H7.333v2.133l-1.066-1.066-.934.933L8 14.667z","fill":"currentColor"}})])
          )
        }
      }
    